import { apiFetch } from '../lib/api';

export interface CoverageHeadline {
  vehicles: number;
  vehicleBps: number;
  wheelsTotal: number;
  wheelsEligible: number;
  vehiclesWithAnyMatch: number;
}
export interface CoverageTiers {
  ok: number;
  tier1: number;
  tier0: number;
  total: number;
}
export interface CoverageByBp {
  bp: string;
  vehicles: number;
  ok: number;
  tier1: number;
  tier0: number;
}
export interface CoverageByMake {
  make: string;
  vehicles: number;
  uncovered: number;
  pct_uncovered: number;
}
export interface CoverageByYear {
  year: number;
  vehicles: number;
  uncovered: number;
  pct_uncovered: number;
}
export interface CoverageSampleRow {
  vehicle_id: number;
  year: number;
  make_slug: string;
  model_slug: string;
  submodel: string | null;
  body_config: string | null;
  bp: string;
  matches_any: number;
  matches_eligible: number;
  tier: 'tier0' | 'tier1';
}
export interface CoverageTier1Reasons {
  tier1_total: number;
  blocked_by_image: number;
  blocked_by_qty: number;
  blocked_by_inactive: number;
  blocked_by_install_speed: number;
}
export interface DualDrilledStats {
  wheels_total: number;
  wheels_with_any_bp: number;
  wheels_dual_drilled: number;
  avg_bps_per_wheel: number;
  fitment_matches_total: number;
}
export interface Tier0BpCatalogRow {
  bp: string;
  vehicles_affected: number;
  bp_in_catalog: boolean;
  bp_in_eligible_catalog: boolean;
}

export interface CoverageAuditResult {
  generatedAt: string;
  elapsedMs: number;
  headline: CoverageHeadline;
  tiers: CoverageTiers;
  tier1Reasons: CoverageTier1Reasons;
  dualDrilledStats: DualDrilledStats;
  byBp: CoverageByBp[];
  byMake: CoverageByMake[];
  byYear: CoverageByYear[];
  sample: CoverageSampleRow[];
  tier0BpCatalog: Tier0BpCatalogRow[];
}

export function getCoverageAudit(): Promise<CoverageAuditResult> {
  return apiFetch<CoverageAuditResult>('/admin/coverage-audit');
}
